import { useState } from "react";
import { string, func, node } from "prop-types";
import Button from "../../../Button/Button.jsx";

const propTypes = {
  modalTitle: string.isRequired,
  btnText: string.isRequired,
  initialReportTitle: string.isRequired,
  onCancel: func,
  onSubmit: func,
  type: string,
  onExport: func,
  children: node,
};

const TitleForm = (props) => {
  const {
    initialReportTitle,
    onCancel,
    btnText,
    modalTitle,
    onSubmit,
    type,
    onExport,
  } = props;

  const [reportTitle, setReportTitle] = useState(initialReportTitle);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(reportTitle);
    onCancel();
  };

  return (
    <div className="title-form">
      <div className="title-form__container">
        <h2 className="title-form__title">{modalTitle}</h2>
        {type === "edit/save" && (
          <form onSubmit={handleSubmit}>
            <label>
              <div className="title-form__label">Report Title</div>
              <input
                className="title-form__set-title-input sc-form-item__field"
                onChange={(e) => setReportTitle(e.target.value)}
                value={reportTitle}
              />
            </label>
            <div className="title-form__btn-container">
              <Button className="btn--primary" type="submit">
                {btnText}
              </Button>
              <Button
                className="btn--primary-ghost"
                onClick={onCancel}
                type="button"
              >
                cancel
              </Button>
            </div>
          </form>
        )}

        {type === "export" && (
          <div>
            {props.children}
            <Button className="btn--primary" onClick={onExport} type="button">
              {btnText}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

TitleForm.propTypes = propTypes;
export default TitleForm;
